import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDbysWmW-0P5sKBegnudztrhUqUv776Zmc",
  authDomain: "matchesguru.firebaseapp.com",
  projectId: "matchesguru",
  storageBucket: "matchesguru.firebasestorage.app",
  messagingSenderId: "413266747271",
  appId: "1:413266747271:web:c6345ff3ca4d0d7be5bd22",
  measurementId: "G-HY3F8RXTX6",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
